<template>
  <div class="p-4">
    <h6>Meine Beratungs-Unterstützung für dich:</h6>
    <ul>
      <li>
        Optimierte Kommunikation:
        <br> In der Partnerschaft, in deinem Umfeld, im Job
        <br> Netzwerken einfach gemacht
      </li>
      <li>
        Unterlagenerstellung:
        <br>
        Bewerbungen, Abschlussarbeiten
      </li>
      <li>
        Selbstptäsentation:
        <br> Vorstellungsgespräche erfolgreich führen
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    showFancyToolbar: { type: Boolean, required: true },
  },
};
</script>
